export default "__VITE_ASSET__tfYfPcK9__"